export default {
    results: {
        missingTerms: "Termes manquants :",
        resultsCount: "{count, plural, =0 {aucune réponse} one {# réponse} other {# réponses}}",
    },
    userRatings: {
        average: "Moyenne : {average}"
    },
};
